import { authClient, API } from "../../utils/index";

export const getPromoPortfolioSectorsAdmin = () => {
	return authClient().get(`${API}/promo-portfolio-sector?all=1`);
};

export const getPromoPortfolioSectorById = (id) => {
	return authClient().get(`${API}/promo-portfolio-sector/${id}`);
};

export const postPromoPortfolioSector = (body) => {
	return authClient().post(`${API}/promo-portfolio-sector`, body);
};

export const putPromoPortfolioSector = (id, body) => {
	return authClient().put(`${API}/promo-portfolio-sector/${id}`, body);
};

export const movePromoPortfolioSector = (id, direction) => {
	return authClient().post(`${API}/promo-portfolio-sector/${id}/move`, { direction });
};

export const deletePromoPortfolioSector = (id) => {
	return authClient().delete(`${API}/promo-portfolio-sector/${id}`);
};
